import { RouteObject } from 'react-router-dom';
import { DesignSystemLayout } from '@pages/DesignSystem/DesignSystemLayout';

export const designSystemRoutes: RouteObject[] = [
  {
    path: '/design-system',
    element: <DesignSystemLayout />
  }
];
